// src/pages/Home.jsx
import React, { useState, useEffect, useRef} from 'react';
import { Link } from 'react-router-dom';
// import '../styles/Home.css';
import { useLocation } from 'react-router-dom';

import HeroSection from '../components/home/HeroSection';
import Storytelling from '../components/home/StoryTelling';
import Instruction from '../components/home/Instruction';
import EventSection from '../components/home/EventSection';

const Home = () => {

  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [hash]);

  

  const scrollToSection = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="override-homepage">
      {/* --- 6. EMBEDDED CSS (Replaces local .css file) --- */}
      <style>{`
        /* Core Layout */
        .override-homepage {
          overflow-x: hidden;
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
        }

        @keyframes pulse-green {
          0% { box-shadow: 0 0 0 0 rgba(73, 108, 28, 0.7); }
          70% { box-shadow: 0 0 0 10px rgba(73, 108, 28, 0); }
          100% { box-shadow: 0 0 0 0 rgba(73, 108, 28, 0); }
        }

        @keyframes slideInList {
          from { opacity: 0; transform: translateX(-10px); }
          to { opacity: 1; transform: translateX(0); }
        }

        .animate-list-change {
          animation: slideInList 0.5s ease-out forwards;
        }

        /* Section 2: Map & Story */
        .home-page {
          background-color: #FFF9E6;
        }
        
        .homepage-storytelling {
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 2% 0;
        }

      `}</style>

      {/* --- Hero Section --- */}
      <HeroSection onScrollClick={scrollToSection} />
      

      <div className="home-page">
        {/* --- Storytelling Section --- */}
        <div id="homepage-section-2" className="homepage-storytelling">
          <Storytelling onScrollClick={scrollToSection} />
        </div>

        {/* --- Instructions Section --- */}
        <Instruction onScrollClick={scrollToSection} />
        
      </div>

      {/* --- Events & Communities Section --- */}
      <div id="homepage-eventscomm-section" className="events-communities-section">
        <EventSection />
      </div>
    </div>
  );
};

export default Home;